import React, { useEffect, useState } from 'react';
import styles from "./Footer.module.css";
import facebook from "../../assets/Social Media.svg";
import insta from "../../assets/Social Media (1).svg";
import tweet from "../../assets/Social Media (2).svg";
import EprocurementLogo from "../../assets/SGR.svg";
import { NavLink, useLocation, useNavigate } from "react-router-dom";

const Footer = () => {
  const location = useLocation();
  const navigate = useNavigate();
 const getCurrentYear = () => new Date().getFullYear();
  
 const goToPageTop = (path) => {
    navigate(path);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
      };


  return (
    <footer className={styles.footer}>
      {/* Background Logo Placeholder */}
      <div className={styles.bgLogo} />

        
         {/* <div 
        className={styles.flexheader}
        > 
            <h4 className={styles.heading1}>Projects</h4>
            <h4 className={styles.heading1}>Monthly Reports</h4>
            <h4 className={styles.heading1}>Open Data</h4>
            <h4 className={styles.heading1}>Open Document</h4>
            <h4 className={styles.heading1}>FAQ</h4>
      
          </div> */}

         <div className={styles.divider} /> 

      <div className={styles.container}>
        {/* Column 1 */}
        <div>
           <img src={EprocurementLogo} alt="Eprocurement Logo" className={styles.logoE} />
        {/* <div 
        // className={styles.flexheader}
        > */}
          

             
          {/* </div> */}

          <h5 className={styles.subTag}>An initiative of the Ogun State Ministry of Human Services & Poverty Alleviation to identify and support qualifying households across all 20 LGAs</h5>
         
        </div>

        {/* Column 2 */}
        <div>
          <h4 className={styles.heading}>PORTAL</h4>
          <ul className={styles.list}>
            <li>Register a Household</li>
            <li>Staff/Officer Login</li>
            <li>Check Application Status</li>
            <li>Download Registration Form</li>
          </ul>
        </div>

        {/* Column 3 */}
        <div>
          <h4 className={styles.heading}>INFORMATION</h4>
          <ul className={styles.list}>
            <li>About the Register</li>
            <li>Eligibility Criteria</li>
            <li>Welfare Programmes</li>
            <li>FAQs</li>
          </ul>
        </div>

        {/* Column 4 */}
        <div>
       
         
          <h4 className={styles.heading}>LEGAL & SUPPORT</h4>

          <ul className={styles.list}>
            <li>Privacy Policy</li>
            <li>Terms of Use</li>
            <li>Data Protection Centre</li>
            <li>Help Centre</li>
           
          </ul>
        </div>
      </div>
   


      {/* Divider */}
      <div className={styles.dividers} />

      {/* Footer Bottom */}
      <div className={styles.footerBottom}>
      <p className={styles.copyright}>
        © {getCurrentYear()} Ogun State Government. All rights reserved. Social Register Portal v1.0
      </p>
      <div className={styles.socials}>
        <p>Terms of Services</p>
        <p>Privacy Policy</p>
        <p>Accessibility</p>
      </div>
      </div>
    </footer>
  );
};

export default Footer;
